import { useMutation, useQueryClient } from "react-query";
import { updateDiagnostic } from "apps/diagnostics/api";
import { IDiagnostic } from "apps/project-iq/models/IDiagnostic";

interface IUpdateDiagnosticParams {
  id: string;
  diagnostic: IDiagnostic;
}

export const useUpdateDiagnostic = (workspaceId: string) => {
  const queryClient = useQueryClient();
  return useMutation<IDiagnostic, Error, IUpdateDiagnosticParams>(
    (params: IUpdateDiagnosticParams) =>
      updateDiagnostic({ id: params.id, diagnostic: params.diagnostic }),
    {
      onSuccess: (data, params) => {
        queryClient.setQueryData(["workspace-diagnostic", params.id], data);
        queryClient.invalidateQueries(["workspace-diagnostics", workspaceId]);
      },
    },
  );
};
